import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const BoltSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default BoltSVG;
